import { Select } from 'antd'
import Flex from 'components/Flex'
import { StyledTabs } from 'components/TabsPaneStyles'
import styled from 'styled-components'
import { COLORS } from 'theme'
export const { Option } = Select
export const StyledTab = styled(StyledTabs)`
  .ant-tabs-content {
    height: 250px !important;

    overflow: scroll;
    &::-webkit-scrollbar {
      display: '';
    }
  }
`

export const SubmitFlex = styled(Flex)`
  gap: 20px;
  padding: 20px;
  border-top: 1px solid ${COLORS.GREY_T_90};
`
export const MenuFlex = styled(Flex)`
  background: ${COLORS.WHITE};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
`
export const Wrapper = styled(Flex)`
  padding: 20px 20px 20px 0;
  gap: 5px;
`
export const Wrappers = styled.div`
  padding: 1rem 0.5rem;
  width: max-content;
`
export const StartMargin = styled.div`
  margin-bottom: 10px;
`
export const EndMargin = styled.div`
  margin-top: 10px;
`

export const ErrorMessage = styled.div`
  color: red;
  margin-top: 10px;
`

export const ClearButton = styled.div`
  margin-top: 20px;
  float: right;
  margin-right: 10px;
  cursor: pointer;
`
export const DegreeWrapper = styled.div`
  width: 400px;
  margin-top: -30px;
`

export const DividerStyle = styled.div`
  height: 1px;
  background-color: #f0f0f0;
  margin: 0;
  padding: 0;
  min-height: 0px !important;
`

export const RankingWrapper = styled.div`
  justify-content: space-between;
  display: flex;
  width: 250px;
  margin-top: 1rem;
`

export const OptionWrapper = styled(Option)`
  min-height: 0px;
  line-height: 0px;
  margin-top: 5px;
`

export const StyledSelect = styled(Select)`
  min-height: 0px !important;
  &.ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: #1890ff;
  }
  &.ant-select-focused:not(.ant-select-disabled).ant-select:not(
      .ant-select-customize-input
    )
    .ant-select-selector {
    border-color: #1890ff;
    box-shadow: none;
  }
  &.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    height: 2.6rem;
    align-items: center;
    border-radius: 0.6rem;
    width: 6rem;
  }
  &.ant-select-item {
    min-height: 0px !important;
    padding: 0px 0px !important;
    line-height: 0px !important;
    margin: 0px !important;
  }
`

export const StyledOption = styled.p`
  display: flex;
  justify-content: center;
  font-size: 18px;
  margin-bottom: 0px;
  margin-top: 25px;
`

export const CenterAlignment = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

export const RankWrapper = styled.div`
  width: 300px;
`
